import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class ServiceListItemHeader extends Component {
  render() {
    const { title, helpText, secondaryInfo, onClick } = this.props;
    let helpTextClasses = cx({
      helpText: true,
      inline: secondaryInfo,
    });

    if (secondaryInfo) {
      var secondaryInfoItem = <div className="secondaryInfo">{secondaryInfo}</div>;
    }
    if (helpText) {
      var helpTextItem = <div className={classnames(helpTextClasses)}>{helpText}</div>;
    }

    let className = cx({
      ServiceListItemHeader: true,
    });

    return (
      <div className={classnames(className)} onClick={onClick}>
        {title}
        {secondaryInfoItem}
        {helpTextItem}
        <div className="itemActions">{this.props.children}</div>
      </div>
    );
  }
}
